import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "fabricWeightInput" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "form-check form-check-inline" }
const _hoisted_5 = ["checked"]
const _hoisted_6 = {
  class: "form-check-label",
  for: "inlineRadio1"
}
const _hoisted_7 = { class: "form-check form-check-inline" }
const _hoisted_8 = ["checked"]
const _hoisted_9 = {
  class: "form-check-label",
  for: "inlineRadio2"
}
const _hoisted_10 = { class: "form-check form-check-inline" }
const _hoisted_11 = ["checked"]
const _hoisted_12 = {
  class: "form-check-label",
  for: "inlineRadio3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showFields)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.Title), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("input", {
              class: "form-check-input",
              type: "radio",
              name: "inlineRadioOptions",
              id: "inlineRadio1",
              value: "standard",
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onChange', _ctx.handleEmit($event.target)))),
              checked: _ctx.weightType == 'standard'
            }, null, 40, _hoisted_5),
            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.standard), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("input", {
              class: "form-check-input",
              type: "radio",
              name: "inlineRadioOptions",
              id: "inlineRadio2",
              value: "heavy",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onChange', _ctx.handleEmit($event.target)))),
              checked: _ctx.weightType == 'heavy'
            }, null, 40, _hoisted_8),
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.heavy), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("input", {
              class: "form-check-input",
              type: "radio",
              name: "inlineRadioOptions",
              id: "inlineRadio3",
              value: "light",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onChange', _ctx.handleEmit($event.target)))),
              checked: _ctx.weightType == 'light'
            }, null, 40, _hoisted_11),
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.light), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}